import { HOST } from '@/utils/getBaseUrl'

export const getImageUrl = (fileName: string) => {
  return `${HOST}/img/${fileName}`
}
